import { QueryClient } from "@tanstack/react-query";

/**
 * Single app-wide React Query client. Module-level singleton so StrictMode's
 * double-render does not recreate the cache. Phase D introduces React Query for
 * the signals feed (infinite query per ownership tab) and the detail modal
 * (record fetched by id); config here is deliberately conservative.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Feed data changes server-side but not second-to-second; keep it warm.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});
